import React from 'react';
import PropTypes from 'prop-types';
import BabyEditContainer from '../containers/BabyEditContainer';
import Modal from './Modal';

export default function BabyEditorModal(props) {
  if (!props.initialValues) {
    return null;
  }
  
  return (
    <Modal isOpen={props.isOpen} onRequestClose={props.onRequestClose}>
      <BabyEditContainer
        baby={props.initialValues}
        onRequestClose={props.onRequestClose}
        onBabySaved={props.onBabySaved}
        onCancelClicked={props.onRequestClose}
      />
    </Modal>
  );
}

BabyEditorModal.defaultProps = {
  initialValues: null
};

BabyEditorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onBabySaved: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    colorScheme: PropTypes.string.isRequired
  })
};



// WEBPACK FOOTER //
// ./src/components/BabyEditorModal.js